// eslint-disable-next-line import/prefer-default-export
export const PROGRAM_FIELD_PRESETS = [
  {
    token: 'program.programName',
    id: 'programName',
    labelKey: 'templates.program.programName',
    category: 'program',
    type: 'text',
  },
  {
    token: 'program.programIndex',
    id: 'programIndex',
    labelKey: 'templates.program.programIndex',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'programIndex',
  },
  {
    token: 'program.primaryMetric',
    id: 'primaryMetric',
    labelKey: 'templates.program.measurementMetric',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'programPrimaryMetric',
  },
  {
    token: 'program.workflow',
    id: 'workflow',
    labelKey: 'insights.chart.masteryCriteria',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'programMasteryCriteria',
  },
  {
    token: 'program.completionPercentage',
    id: 'completionPercentage',
    labelKey: 'progress.columnsCompletionPercentageLabel',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'programCompletionPercentage',
  },
  {
    token: 'program.treatmentArea',
    id: 'treatmentArea',
    labelKey: 'templates.program.treatmentArea',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'treatmentAreaLabel',
  },
  {
    token: 'program.treatmentAreaCategoryLabel',
    id: 'treatmentAreaCategoryLabel',
    labelKey: 'templates.program.treatmentAreaCategoryLabel',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'treatmentAreaCategoryLabel',
  },
  {
    token: 'program.subTreatmentArea',
    id: 'subTreatmentArea',
    labelKey: 'templates.program.subTreatmentArea',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'subTreatmentAreaLabel',
  },
  {
    token: 'program.baseline',
    id: 'baseline',
    labelKey: 'templates.program.baseline',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'baselineLabel',
  },
  {
    token: 'program.objective',
    id: 'objective',
    labelKey: 'templates.program.objective',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'objectiveLabel',
  },
  {
    token: 'program.statusChange_baseline',
    id: 'statusChange_baseline',
    labelKey: 'templates.program.statusChange_baseline',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_baseline',
  },
  {
    token: 'program.statusChange_active',
    id: 'statusChange_active',
    labelKey: 'templates.program.statusChange_active',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_active',
  },
  {
    token: 'program.statusChange_maintenance',
    id: 'statusChange_maintenance',
    labelKey: 'templates.program.statusChange_maintenance',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_maintenance',
  },
  {
    token: 'program.statusChange_closed',
    id: 'statusChange_closed',
    labelKey: 'templates.program.statusChange_closed',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_closed',
  },
  {
    token: 'program.statusChange_hold',
    id: 'statusChange_hold',
    labelKey: 'templates.program.statusChange_hold',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_hold',
  },
  {
    token: 'program.statusChange_discontinued',
    id: 'statusChange_discontinued',
    labelKey: 'templates.program.statusChange_discontinued',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'statusChange_discontinued',
  },
  {
    token: 'program.plannedMasteryTimeframe',
    id: 'plannedMasteryTimeframe',
    labelKey: 'templates.program.plannedMasteryTimeframe',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'plannedMasteryTimeframe',
  },
  {
    token: 'program.plannedMasteryDate',
    id: 'plannedMasteryDate',
    labelKey: 'templates.program.plannedMasteryDate',
    category: 'program',
    type: 'calculated',
    calculateFunc: 'plannedMasteryDate',
  },
];

/**
 * The presets the Planned Mastery pilot adds. Dropped from the dynamic-field list for
 * clinics outside the pilot, so the tokens are not offered where the feature is hidden.
 */
export const PLANNED_MASTERY_FIELD_IDS = ['plannedMasteryTimeframe', 'plannedMasteryDate'];
